export class YaDisk {

    constructor() {
        this.token = window.localStorage.yandexToken ?? null;
        this.path = null;
        this.isAuthorized = false;

        const urlParams = new URLSearchParams(window.location.search),
            code = urlParams.get('code');

        if (code) {
            window.localStorage.setItem('yandexCode', code);
            document.location = `${window.location.origin}${window.location.pathname}`;
        } else if (window.localStorage.yandexCode) {
            return new Promise(resolve => {
                this.getToken(window.localStorage.yandexCode)
                    .then(token => {
                        window.localStorage.removeItem('yandexCode');
                        window.localStorage.setItem('yandexToken', token);
                        this.token = token;
                        return this.getAppFolder();
                    })
                    .then(path => {
                        window.localStorage.setItem('isAuthorized', 'true');
                        this.isAuthorized = true;
                        this.path = path;
                        resolve(this);
                    })
                    .catch(() => {
                        window.localStorage.setItem('isAuthorized', 'false');
                        this.isAuthorized = false;
                        console.error('YaDisk constructor error (getToken from yandexCode)');
                        resolve(this);
                    });
            });
        } else if (this.token) {
            return new Promise(resolve => {
                this.getAppFolder()
                    .then(path => {
                        window.localStorage.setItem('isAuthorized', 'true');
                        this.isAuthorized = true;
                        this.path = path;
                        resolve(this);
                    })
                    .catch(() => {
                        window.localStorage.setItem('isAuthorized', 'false');
                        window.localStorage.removeItem('yandexToken');
                        this.isAuthorized = false;
                        this.token = null;
                        console.error('YaDisk constructor error (getAppFolder from yandexToken)');
                        resolve(this);
                    })
            });
        } else {
            return new Promise(resolve => {
                window.localStorage.removeItem('authService');
                resolve(this);
            });
        }
    }

    logout() {
        this.token = null;
        this.path = null;
        this.isAuthorized = false;
        window.localStorage.removeItem('authService');
        window.localStorage.removeItem('yandexToken');
        window.localStorage.setItem('isAuthorized', 'false');
        return this;
    };

    getToken(code) {
        const url = 'https://oauth.yandex.ru/token',
            formData = new FormData();

        formData.append('grant_type', 'authorization_code');
        formData.append('code', code);
        formData.append('client_id', '23640237743d46c2bc0ce60fff2f1275');
        formData.append('client_secret', '16723ce078384908bd52ddbf295c8cf7');

        return fetch(url, { method: 'POST', body: formData })
            .then(response => {
                if (!response.ok) throw new Error('getToken response error');
                return response.json();
            })
            .then(result => result['access_token'])
            .catch(err => {
                console.error(err);
                return Promise.reject(false);
            });
    }

    getAppFolder() {
        const url = new URL('https://cloud-api.yandex.net/v1/disk/resources');
        url.searchParams.set('path', 'app:/');

        return fetch(url, {
            headers: {
                'Authorization': `OAuth ${this.token}`
            },
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) throw new Error('getAppFolder response error');
                return response.json();
            })
            .then(result => {
                return result['path'];
            })
            .catch(err => {
                console.error(err);
                return Promise.reject(false);
            });
    }

    async getUploadLink(fileName) {
        const url = new URL('https://cloud-api.yandex.net/v1/disk/resources/upload');
        url.searchParams.set('path', `${this.path}/${fileName}`);
        url.searchParams.set('overwrite', 'true');
        let response = await fetch(url, {
            headers: {
                'Authorization': `OAuth ${this.token}`
            },
            method: 'GET'
        });
        if (response.ok) {
            let result = await response.json();
            return result['href'];
        } else {
            console.error(response);
            return false;
        }
    }

    async getDownloadLink(fileName) {
        const url = new URL('https://cloud-api.yandex.net/v1/disk/resources/download');
        url.searchParams.set('path', `${this.path}/${fileName}`);
        let response = await fetch(url, {
            headers: {
                'Authorization': `OAuth ${this.token}`
            },
            method: 'GET'
        });
        if (response.ok) {
            let result = await response.json();
            return result['href'];
        } else {
            console.error(response);
            return false;
        }
    }

    async uploadData(uploadLink, dataObj) {
        const url = uploadLink,
            blob = new Blob([JSON.stringify(dataObj, null, 2)], { type: 'application/json' });
        let response = await fetch(url, {
            method: 'PUT',
            body: blob
        });
        if (response.ok) {
            return true;
        } else {
            console.error(response.status);
            return false;
        }
    }

    async downloadData(downloadLink) {
        const url = downloadLink;
        let response = await fetch(url, {
            referrerPolicy: "no-referrer",
        });
        if (response.ok) {
            let result = await response.json();
            return result;
        } else {
            console.error(response.status);
            console.log('responseErr', response);
            return false;
        }
    }

    async getMetaModified(fileName) {
        const url = new URL('https://cloud-api.yandex.net/v1/disk/resources');
        url.searchParams.set('path', `${this.path}/${fileName}`);
        url.searchParams.set('fields', 'modified');
        let response = await fetch(url, {
            headers: {
                'Authorization': `OAuth ${this.token}`
            },
        });
        if (response.ok) {
            let result = await response.json();
            return +new Date(result.modified);
        } else {
            console.error(response);
            return false;
        }
    };
}